import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/note/:selected",
    name: "note",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",

    component: function () {
      return import("../views/AboutView.vue");
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
